<template>
    <div class="header">
        <div class="header__section">
            <div class="header__logo">🤘</div>

            <nav>
                <ul>
                    <li><router-link v-b-tooltip.hover.right title="Discover" to="/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg></router-link></li>
                    <li><router-link v-b-tooltip.hover.right title="My gear" to="/gear"><svg fill="none" height="28" viewBox="0 0 20 28" width="20" xmlns="http://www.w3.org/2000/svg"><g stroke="#fff"><rect height="27" rx="2.5" width="19" x=".5" y=".5"/><rect height="11" rx="2.5" width="19" x=".5" y="16.5"/><circle cx="6" cy="9" r="2.5"/><circle cx="14" cy="9" r="2.5"/></g></svg></router-link></li>
                    <li><router-link v-b-tooltip.hover.right title="My songs" to="/songs"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="feather feather-music"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg></router-link></li>
                    <li><router-link v-b-tooltip.hover.right title="My profile" to="/profile"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></router-link></li>
                    <li v-if="currentUser && currentUser.uid === '6b2v7GOuoLVZ1d4Sbrht4eWXGdv1'"><router-link v-b-tooltip.hover.right title="Controle" to="/controle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><path d="M3 12h18M3 6h18M3 18h18"/></svg></router-link></li>
                </ul>
            </nav>
        </div>

    </div>
</template>

<script>
//import firebase from "firebase";
//import router from "../router";
import { mapState } from 'vuex'
export default {
    data() {
        return {
            user: null,
        };
    },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {
    },
    created() {
        /*firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.user = user;
            } else {
                router.push("/login");
            }
        });*/
    }
}
</script>